import React from 'react';
import {
  Link
} from "react-router-dom";
import './Books.css';

function Books() {
    let books = [
        {
            bookLogo: "images/logo-vandt.jpg", 
            alt: "Van Gogh Book Cover", 
            title: "Vincent and Theo Van Gogh",
            amazonURL: "https://www.amazon.com/Vincent-Theo-Van-Gogh-Rotonda/dp/1519262280/",
            payPalId: "C8YBD5V4YK3MG",
            emailMailTo: "mailto:s7091@sbcglobal.net?subject=Purchase%20Van%20Gogh%20Book%201%20Request",
            samples: [{
                url: "/sample/day-with-vincent",
                title: "A Day with Vincent"
            }, {
                url: "/sample/live-only-to-paint",
                title: "I Live Only to Paint"
            }, {
                url: "/sample/what-they-dont-like-about-me",
                title: "What is it They Don't Like About Me"
            }]
        }, {
            bookLogo: "images/logo-ehs.gif", 
            alt: "Entering the Holy Spirit Book Cover", 
            title: "Entering the Holy Spirit",
            amazonURL: "https://www.amazon.com/Entering-Holy-Spirit-Joe-Rotonda/dp/1519262418/",
            payPalId: "C8YBD5V4YK3MG",
            emailMailTo: "mailto:s7091@sbcglobal.net?subject=Purchase%20Enter%20the%20Holy%20Spirit%20Book%202%20Request",
            samples: [{
                url: "/sample/who-will",
                title: "Who Will"
            }, {
                url: "/sample/and-jesus",
                title: "And Jesus"
            }, {
                url: "/sample/sin-belongs",
                title: "Sin Belongs to Satan"
            }]
        }, {
            bookLogo: "images/holy-spirit-within.jpg", 
            alt: "Holy Spirit Within Book Cover", 
            title: "The Holy Spirit Within",
            amazonURL: "https://www.amazon.com/Holy-Spirit-Within-Us/dp/1519525214/",
            payPalId: "C8YBD5V4YK3MG",
            emailMailTo: "mailto:s7091@sbcglobal.net?subject=Purchase%20The%20Holy%20Spirit%20Within%20Us%20Book%203%20Request",
            samples: [{
                url: "/sample/another-portion",
                title: "Another Portion of Me is Beyond the Grave"
            }, {
                url: "/sample/god-watches",
                title: "God Watches"
            }, {
                url: "/sample/i-am-here",
                title: "I am Here for You, Waiting for your Prayers"
            }]
        }, {
            bookLogo: "images/heart-mind-soul.jpg", 
            alt: "Poems for the Heart, Mind, and Soul Cover", 
            title: "Poems for the Heart, Mind, and Soul",
            amazonURL: "https://www.amazon.com/dp/B09TR6YJL3",
            payPalId: "C8YBD5V4YK3MG",
            emailMailTo: "mailto:s7091@sbcglobal.net?subject=Purchase%20Poems%20for%20the%20Heart,%20Mind,%20and%20Soul%20Book%203%20Request",
            samples: []
        }, {
            bookLogo: "images/jesus-christ-and-the-divine-helper.jpg", 
            alt: "Jesus Christ And The Divine Helper Cover", 
            title: "Jesus Christ And The Divine Helper",
            amazonURL: "https://www.amazon.com/dp/B09WQBKP4L",
            payPalId: "C8YBD5V4YK3MG",
            emailMailTo: "mailto:s7091@sbcglobal.net?subject=Jesus%20Christ%20And%20The%20Divine%20Helper%20Paperback%203%20Request",
            samples: [{
                url: "/sample-text/god-will",
                title: "God Will"
            }, {
                url: "/sample-text/greater-is-he",
                title: "Greater is He"
            }, {
                url: "/sample-text/god-needs-to-be",
                title: "God Needs to Be"
            }, {
                url: "/sample-text/god-planted-the-seed",
                title: "God Planted the Seed"
            }]
        }
    ]

    return (
        <div>
            <div className="jumbotron">
                <div className="container">
                    <h1 className="display-4">Available Books</h1>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    {books.map((item, i) => {
                        return (
                            <div className="col-md-4 col-sm-6 col-12 d-flex">
                                <div className="card mb-4 shadow-sm flex-fill">
                                <img width="350" height="500" src={item.bookLogo} className="card-img-top" alt={item.alt} />
                                    <div className="card-body">
                                        <p className="card-text">{item.title}</p>
                                        <ul>
                                            {item.samples.map((sample, i) => {
                                                return (
                                                    <li><Link to={sample.url}>{sample.title}</Link></li>
                                                );
                                            })}
                                        </ul>
                                        <div className="card-footer-sticky">
                                            <a href={item.amazonURL} className="btn btn-primary mr-1" target="_blank" rel="noopener noreferrer">Amazon</a>
                                            {/* <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="paypal">
                                                <input type="hidden" name="cmd" value="_s-xclick" />
                                                <input type="hidden" name="hosted_button_id" value={item.payPalId} />
                                                <button type="button" className="btn btn-primary">PayPal</button>
                                            </form> */}
                                            {/* <a href={item.emailMailTo} className="btn btn-primary mr-1" target="_blank" rel="noopener noreferrer">Email</a> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default Books;